import { useState, useEffect, SyntheticEvent } from 'react'
import { useNavigate } from 'react-router-dom';
import { BackBtn } from '../../components/buttons/ExportBtn';
import OtpInput from '../../components/inputs/OtpInput';
import { useDispatch, useSelector } from 'react-redux';
import { verifyLogin } from '../../redux/slice/authSlice';
import { Dispatch } from '../../redux/store';
import Button from '../../components/buttons/Button';




const Verification = () => {

    const navigate = useNavigate();
    const dispatch = useDispatch<Dispatch>();
    
    const [otp, setOtp] = useState('');
    const [adminId, setAdminId] = useState<string | null>(null);

    const handleOtpChange = (val: string) => {
        setOtp(val);
    };
    
    const isButtonEnabled = otp.length === 4;

    useEffect(() => {
        const loginDataString = localStorage.getItem('loginData');
        if (loginDataString) {
            const loginData = JSON.parse(loginDataString);
            setAdminId(loginData.data?.user?.id || null);
        }
    }, []);


    const { status } = useSelector((state: any) => state.auth);

    const handleSubmit = (e: SyntheticEvent<HTMLFormElement>) => {
        e.preventDefault();
        console.log('Submitting OTP:', otp, 'Admin ID:', adminId);
        if (otp.length === 4 && adminId) {
            dispatch(verifyLogin({ otp, adminId }));
        }
    }   


  return (
    <form onSubmit={handleSubmit} className='rounded-3xl shadow-lg bg-bgWhite p-[3rem] flex flex-col justify-center items-center gap-[1rem]'>
        <header className="flex gap-3 items-center">
            <img src="/frame.svg" alt="" className="" />
            <h1 className="text-5xl font-semibold">Two-Factor <br /> Authentication</h1>
        </header>

        <p className='text-lg text-[#000] text-center'>Check your email inbox for a 4-digit OTP. Enter it below</p>

        <section className="flex flex-col gap-1">
            <OtpInput className={`${status === 'failed' ? 'text-[crimson]' : 'text-[#026E78] '}`} onChange={handleOtpChange}/>
            { status === 'failed' &&
            <div className="flex items-center justify-between">
                <span className='text-red-400'>Incorrect OTP</span>
                {/* <span className="text-lg text-[#6922D1] cursor-pointer font-semibold flex">Resend OTP</span> */}
            </div>
            }
        </section>

        <div className="flex justify-between w-full">
            <BackBtn onClick={() => navigate('/auth/login')} text='Go Back'/>

            <Button
                loading={status === 'pending'}
                type='submit'
                // onClick={ status === 'failed' ? ResendOTP : verifyOtp }
                className='text-bgWhite rounded-3xl py-2 px-7 bg-bgPurple'
                rightIcon={<img src="/autharr.svg" alt="" className="flex my-auto" />} 
                disabled={!isButtonEnabled}
            >
                Continue
            </Button>
        </div>
    </form>
  )
}

export default Verification;
